module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/pxiByp8kv8JHgFVrLCz7Z1xlFd2JQEk.f4f17fd5.woff2";